import { render, staticRenderFns } from "./NIDA.vue?vue&type=template&id=2ab3a581"
import script from "./NIDA.vue?vue&type=script&lang=js"
export * from "./NIDA.vue?vue&type=script&lang=js"
import style0 from "./NIDA.vue?vue&type=style&index=0&id=2ab3a581&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports